import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ColorSchemeService } from '../services/color-scheme/color-scheme.service';
import { UpdateColorScheme } from './user-settings.actions';

import { userSettingsStateDefaults, UserSettingsStateModel } from './user-settings.models';

@State<UserSettingsStateModel>({
    name: userSettingsStateDefaults.sliceName,
    defaults: userSettingsStateDefaults.defaults
})
@Injectable()
export class UserSettingsState {
    constructor(
        private _colorSchemeService: ColorSchemeService
    ) { }

    @Selector()
    public static colorScheme(state: UserSettingsStateModel) {
        return state.colorScheme;
    }

    @Action(UpdateColorScheme)
    private updateColorScheme(ctx: StateContext<UserSettingsStateModel>, { colorScheme }: UpdateColorScheme) {
        this._colorSchemeService.update(colorScheme);

        return ctx.patchState({
            colorScheme: colorScheme
        });
    }
}
